import { defineMessages } from 'react-intl';

export default defineMessages({
  claimNumber: {
    id: 'claims.claim_number',
  },
  client: {
    id: 'claims.client',
  },
  lossDate: {
    id: 'claims.loss_date',
  },
  openingDate: {
    id: 'claims.opening_date',
  },
  numberOfVictim: {
    id: 'claims.number_of_victim',
  },
  preOpeningDate: {
    id: 'claims.preopening_date',
  },
  displayAllClaimsButton: {
    id: 'home_page.display_all_claims',
  },
  title: {
    id: 'pending_claims.manager.title',
  },
  lossHour: {
    id: 'claims.loss_hour',
  },
  claimPlace: {
    id: 'claims.claim_place',
  },
  registrationNumber: {
    id: 'claims.registration_number',
  },
  noPendingFilesMessage: {
    id: 'no_pending_files.message',
  },
  noPendingFilesTitle: {
    id: 'no_pending_files.title',
  },
});
